"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAdapter = void 0;
var utils_1 = require("../utils/utils");
var base_1 = require("./base");
var is_nil_1 = require("../utils/is-nil");
var event_trigger_1 = require("../utils/event-trigger");
var extend_1 = require("../utils/extend");
var SelectAdapter = /** @class */ (function (_super) {
    __extends(SelectAdapter, _super);
    function SelectAdapter(core, options) {
        var _this = _super.call(this) || this;
        _this.core = core;
        _this.options = options;
        return _this;
    }
    SelectAdapter.prototype.current = function (callback) {
        var _this = this;
        var data = Array.prototype.map.call(this.core.element.querySelectorAll(':checked'), function (selectedElement) { return _this.item(selectedElement); });
        callback(data);
    };
    SelectAdapter.prototype.select = function (data) {
        var _this = this;
        data.selected = true;
        // If data.element is a DOM node, use it instead
        if (!is_nil_1.isNil(data.element) && data.element.tagName.toLowerCase() === 'option') {
            data.element.selected = true;
            this.triggerChange();
            return;
        }
        if (this.core.element.multiple) {
            this.current(function (currentData) {
                var val = [];
                data = [data];
                data.push.apply(data, currentData);
                for (var d = 0; d < data.length; d++) {
                    var id = data[d].id;
                    if (val.indexOf(id) === -1) {
                        val.push(id);
                    }
                }
                _this.triggerChange(val);
            });
        }
        else {
            this.triggerChange(data.id);
        }
    };
    SelectAdapter.prototype.triggerChange = function (value) {
        if (value !== undefined) {
            this.core.val(value);
        }
        event_trigger_1.eventTrigger(this.core.element, 'input');
        event_trigger_1.eventTrigger(this.core.element, 'change');
    };
    SelectAdapter.prototype.unselect = function (data) {
        var _this = this;
        if (!this.core.element.multiple) {
            return;
        }
        data.selected = false;
        if (data.element != null &&
            data.element.tagName.toLowerCase() === 'option') {
            data.element.selected = false;
            this.triggerChange();
            return;
        }
        this.current(function (currentData) {
            var val = [];
            for (var d = 0; d < currentData.length; d++) {
                var id = currentData[d].id;
                if (id !== data.id && val.indexOf(id) === -1) {
                    val.push(id);
                }
            }
            _this.triggerChange(val);
        });
    };
    SelectAdapter.prototype.binding = function (select, container) {
        var _this = this;
        this.container = select;
        select.on('select', function (params) {
            _this.select(params.data);
        });
        select.on('unselect', function (params) {
            _this.unselect(params.data);
        });
    };
    SelectAdapter.prototype.destroy = function () {
        // Remove anything added to child elements
        Array.from(this.core.element.getElementsByTagName('*')).forEach(function (el) {
            // Remove any custom data set by TsSelect2
            utils_1.Utils.RemoveData(el);
        });
    };
    SelectAdapter.prototype.query = function (params, callback) {
        var _this = this;
        var results = [];
        var options = Array.from(this.core.element.children);
        options.forEach(function (el) {
            if (el.tagName.toLowerCase() !== 'option' && el.tagName.toLowerCase() !== 'optgroup') {
                return;
            }
            var option = _this.item(el);
            var matches = _this.matches(params, option);
            if (matches !== null) {
                results.push(matches);
            }
        });
        callback({ results: results });
    };
    SelectAdapter.prototype.addOptions = function (options) {
        var _a;
        (_a = this.core.element).append.apply(_a, options);
    };
    SelectAdapter.prototype.option = function (data) {
        var option;
        if (data.children) {
            option = document.createElement('optgroup');
            option.label = data.text;
        }
        else {
            option = document.createElement('option');
            if (option.textContent !== undefined) {
                option.textContent = data.text;
            }
            else {
                option.innerText = data.text;
            }
        }
        if (data.id !== undefined) {
            option.value = data.id;
        }
        if (data.disabled) {
            option.disabled = true;
        }
        if (data.selected) {
            option.selected = true;
        }
        if (data.title) {
            option.title = data.title;
        }
        var normalizedData = this.normalizeItem(data);
        normalizedData.element = option;
        // Override the option's data with the combined data
        utils_1.Utils.StoreData(option, 'data', normalizedData);
        return option;
    };
    SelectAdapter.prototype.item = function (option) {
        var data = utils_1.Utils.GetData(option, 'data');
        if (data != null) {
            return data;
        }
        if (option.tagName.toLowerCase() === 'option') {
            data = {
                id: option.value,
                text: option.innerText,
                disabled: option.disabled,
                selected: option.selected,
                title: option.title
            };
        }
        else if (option.tagName.toLowerCase() === 'optgroup') {
            data = {
                text: option.label,
                children: [],
                title: option.title
            };
            var childrenElements = option.children;
            var children = [];
            for (var c = 0; c < childrenElements.length; c++) {
                var $child = childrenElements[c];
                if ($child.tagName.toLowerCase() !== 'option') {
                    continue;
                }
                var child = this.item($child);
                children.push(child);
            }
            data.children = children;
        }
        data = this.normalizeItem(data);
        data.element = option;
        utils_1.Utils.StoreData(option, 'data', data);
        return data;
    };
    SelectAdapter.prototype.matches = function (params, data) {
        var matcher = this.options.get('matcher');
        return matcher(params, data);
    };
    SelectAdapter.prototype.normalizeItem = function (item) {
        if (item !== Object(item)) {
            item = {
                id: item,
                text: item
            };
        }
        item = extend_1.extend({}, { text: '' }, item);
        var defaults = {
            selected: false,
            disabled: false
        };
        if (item.id != null) {
            item.id = item.id.toString();
        }
        if (item.text != null) {
            item.text = item.text.toString();
        }
        if (item._resultId == null && item.id && this.container != null) {
            item._resultId = this.generateResultId(this.container, item);
        }
        return extend_1.extend({}, defaults, item);
    };
    return SelectAdapter;
}(base_1.BaseAdapter));
exports.SelectAdapter = SelectAdapter;
//# sourceMappingURL=select.js.map